exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".vbt-autcomplete-list[data-v-9a21a6f4]{background-color:#fff!important}", "", {"version":3,"sources":["D:/xampp/htdocs/open_house/ui/src/components/Regis.vue"],"names":[],"mappings":"AACA,uCACE,+BAAqC,CACtC","file":"Regis.vue","sourcesContent":["\n.vbt-autcomplete-list[data-v-9a21a6f4] {\r\n  background-color: #ffffff !important;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0133629b","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Regis.vue
// module id = 314
// module chunks = 3